export const colors = {
  border: 'gray.1',
  content: 'background',
  page: 'gray.0',
  badge: 'background',
};
